<template>
	<div class=" projectmanagement">
		<div class="indexcenterpage">
			<leftnav class="fl" mkcode="E" itemcode="E-XMGL"></leftnav>
			<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
				<govheader :show-video="true" :video-type="5"></govheader>
				<div class="index_left_centerpage">
					<div v-if="userdata.token">

						<!-- 标题盒子开始 -->
						<div class="whitebox right_topbox">
							<div class="right_boxtitle">
								<span class="fl right_title">项目管理</span>
								<div><span class="systemManagement_project fr">所有项目：<span class="orangefont ">{{
									customerdata.length }}</span>个</span> </div>
							</div>
							<div class="projectMane_labelbox">
								<div class="oh">
									<h5 class="title labelfl fl">企业名称</h5>
									<div class="labelfr fl"><el-input v-model="companyname" placeholder="请输入企业名称"
											class="inp_name"></el-input></div>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl">所属行业</h5>
									<div class="labelfr fl">
										<el-select v-model="industry" @change="indse(industry)" clearable>
											<el-option v-for="item in industryoptions1" :key="item.value"
												:label="item.name" :value="item.value"></el-option>
										</el-select>
										<el-select v-model="industry2" clearable>
											<el-option v-for="item in industryoptions2" :key="item.value"
												:label="item.name" :value="item.value"></el-option>
										</el-select>
									</div>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl">跟进状态</h5>
									<div class="labelfr fl"><label v-for="(item, i) in stausoptions" :key="i"
											class="pro_sutauslist"> <input type="checkbox" v-model="stauslist"
												:value="item.paraValue" @change="ch()" />{{ item.paraName }}</label></div>
												<el-tooltip class="item smartTip-text" effect="light" placement="top-start" >
										<i class="el-icon-question listeltootipicon listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											初步接洽（获取资料）<br />
											深入沟通（完善资料）<br />
											项目初评（AI初评）<br />
											项目研判（讨论研判）<br />
											项目推送（推送市州）<br />
											重新推送（推送给新的市州）<br />
											重点跟踪（重点项目持续跟踪）<br />
											项目考察（企业与政府相互考察）<br />
											项目谈判（进入政策谈判阶段）<br />
											项目落地（项目签约落地）<br />
											项目暂停（各种原因，暂停跟踪） <br />
										</div>
									</el-tooltip>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl">录入时间</h5>
									<div class="labelfr fl">
										<el-date-picker v-model="CreationTime" type="date" placeholder="选择日期"
											@change="dateFormat(1, CreationTime)"></el-date-picker>
									</div>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl">最后跟进时间</h5>
									<div class="labelfr fl">
										<el-date-picker v-model="LastTime" type="date" placeholder="选择日期"
											@change="dateFormat(2, LastTime)"></el-date-picker>
									</div>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl">负责人</h5>
									<div class="labelfr fl">
										<el-select v-model="personvalue" placeholder="请选择" clearable><el-option
												v-for="item in personoptions" :key="item.managerId"
												:label="item.managerName" :value="item.managerId"> </el-option>
										</el-select>
									</div>
								</div>
								<div class="oh">
									<h5 class="title labelfl fl"></h5>
									<p class="labelfr fl"><span class="gov_screen"
											@click="getcustomerlist()">筛选</span><span class="rest_btn"
											@click="restfun()">重置</span></p>
								</div>
							</div>
						</div>
						<!-- 项目管理列表 -->
						<div class="systemManagement_table whitebox projectmanagement_tablebox">
							<div class="systemManagement_table_btn">
								<p class="fl">共有<span class="orangefont">&nbsp;{{ total }}&nbsp;</span>个企业</p>
								<ul class="fr">
									<!-- <li :class="ischeckedlist.length>0?'licurt':''"	@click="ischeckedlist.length>0?open():''">移除企业</li> ，已勾选<span		class="orangefont">&nbsp;{{ischeckedlist.length}}&nbsp;</span>个企业 -->
									<li @click="newadd = true;" class="projecte_addcustomer">新增企业</li>
								</ul>
							</div>
							<div class="enterprise_list_box">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th class="projectmanagement_enterprisename">
											<!-- <input type="checkbox"	v-model="checkAll" @click="checkedall" /> -->
											<span>企业名称</span>
										</th>
										<th>电话</th>
										<th>负责人</th>
										<th>联系人</th>
										<th>
											<select class="proselect" v-model="sid" @change="schange">
												<option v-for="(item, i) in contact" :value="item.sid"
													:key="'contact' + i">{{ item.value }}</option>
											</select>
										</th>
										<th>
											<select class="proselect" v-model="sid2" @change="schange2(customerdata)">
												<option v-for="(item, i) in stausoptions" :value="item.paraValue" :key="'state' + i"> {{ item.paraName }}</option>
											</select>
										</th>
										<th>创建时间</th>
										<th style="line-height: 20px;">最后<br />跟进时间</th>
										<th>未跟进天数</th>
										<th>备注</th>
										<th>编辑</th>
									</tr>
									<tr v-for="(item, i) in enterpriselist" :key="'enterprise' + i">
										<td class="projectmanagement_enterprisename">
											<!-- <input type="checkbox" v-model="ischeckedlist" @change="checkSingle" :value="item.id"> -->
											<span class="workbench_enterprise_details"
												@click="detailrouterto('/workbenchEnterpriseDetails', item.id)"
												v-if="item.id != ''" :class="item.id != '' ? 'curp' : ''">{{
													item.customerName }}</span>
										</td>
										<td>{{ item.phone != "" ? item.phone : '-' }}</td>
										<td><span>{{ item.managerName }}</span></td>
										<td><span>{{ item.contactList.length > 0 &&
											item.contactList[0].contactName != "" ? item.contactList[0].contactName
											: "-" }}</span>
										</td>
										<td>
											<span v-show="sid == 1"><em>{{ item.weixin != '' ? item.weixin : '暂无微信'
											}}</em></span>
											<span v-show="sid == 2"><em>{{ item.mobile != '' ? item.mobile : '-'
											}}</em></span>
											<span v-show="sid == 3"><em>{{ item.qq != '' ? item.qq : '暂无QQ'
											}}</em></span>
											<span v-show="sid == 4"><em>{{ item.email != '' ? item.email : '-'
											}}</em></span>
											<span v-show="sid == 5"><em>{{ item.email != '' ? item.email : '-'
											}}</em></span>
										</td>
										<td>
											<!-- <span v-show="item.trackStatus == 0">-</span> -->
											<span v-if="item.trackStatus > -1">{{ checkListxd[item.trackStatus-1]
											}}</span>
										</td>
										<td>{{ item.enterTime }}</td>
										<td><span v-if="item.trackTime != ''">{{ item.trackTime }}</span><span
												v-if="item.trackTime == ''">-</span></td>
										<td>{{ item.notrackdays }}</td>
										<td><span v-if="item.remark != ''">{{ item.remark }}</span><span
												v-if="item.remark == ''">无</span></td>
										<td> <span class="curp" @click="detaleConfirm(item.id)">移除</span></td>
									</tr>
								</table>
								<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
									<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
										v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
								</div>
							</div>
							<!-- 新增企业弹框 -->
							<div class="framebgbox" v-show="newadd">
								<div class="framebox">
									<div class="frame">
										<h4>新增企业</h4>
										<div class="projectMane_labelbox_pop">
											<div class="mb-2" style="margin-left: 120px;">
													<el-radio v-model="company" label="1">有项目公司</el-radio>
    												<el-radio v-model="company" label="2">暂无项目公司</el-radio>
												</div>
											<div class="oh">
												<h5 class="title labelfl fl"><em style="color: #f00;">*</em>企业名称</h5>
												<div class="labelfr enterpriseName fl">
													<!-- <el-input v-model="customerName" placeholder="请输入" class="inp_text"> </el-input> -->
													<!-- <el-select v-model="customerName" filterable 
														reserve-keyword placeholder="请输入关键词" 
														no-match-text="无匹配数据" loading-text="正在从企业库筛选...">
														<el-option v-for="item in enterpriseOptions" :key="item.stockCode"
															:label="item.title" :value="item.title">
														</el-option>
													</el-select> -->
													<el-autocomplete v-show="company == '1'"
													v-model="customerName"
													:debounce="1000"
													:fetch-suggestions="fetchSuggestions"
													placeholder="请输入关键词"
													:trigger-on-focus="false"
													@select="handleSelect"
													></el-autocomplete>
													<el-input v-show="company == '2'" v-model="customerName" placeholder="请输入项目名称" class="inp_text"></el-input>
													<el-button v-show="company == '1'" class="searchbtn" size="small"  type="primary" icon="el-icon-search" :loading="loading" @click="_executeRemoteMethod">搜索</el-button>
												</div>
												
											</div>
											<div class="oh">
												<h5 class="title labelfl fl"><em style="color: #f00;">*</em>跟进状态</h5>
												<div class="labelfr fl"><el-select v-model="trackStatusvalue"
														placeholder="请选择" @change="stu()"><el-option
															v-for="item in stausoptions" :key="item.paraValue"
															:label="item.paraName"
															:value="item.paraValue">{{ item.paraName }}</el-option></el-select></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">电 话</h5>
												<div class="labelfr fl"><el-input v-model="addphone" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">邮 箱</h5>
												<div class="labelfr fl"><el-input v-model="addemail" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">备 注</h5>
												<div class="labelfr fl"><el-input v-model="addremark" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh" v-show="erromsg.length > 0">
												<h5 class="title labelfl fl"></h5>
												<div class="labelfr fl">
													<p class="errortips redfont">{{ erromsg }}</p>
												</div>
											</div>
											<div class="oh btnbox ">
												<span class="basebtn fl" @click="addcus()">确定</span> <span
													class="graybtn fr" @click="newadd = false">取消</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 弹框end -->
						</div>

					</div>
					<div v-else>
						<div class="heightVh95 whitebox container-flex-center">
							<freeUserTips :type="4" :bgtype="0"></freeUserTips>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { param } from "jquery";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'projectmanagement',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {}, title: "项目管理",
			stauslist: [],
			checkListxd: ['初访', '有意向', '已签约', '已落地', '暂时搁置', '-', '-'],
			stausoptions: [],
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 20, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10,  //最大页数
			checked: true,
			newadd: false, //新增用户弹框是否开启
			personoptions: [],
			trackStatusvalue: '',
			personvalue: '', //负责人
			value: '',
			value1: '',
			input: '',
			customerdata: [
				// {id:1,enterprisename:"北京博越盛华文化发展有限公司1",resname:"王强",contactname:"王强",wechat:"151454573",satus:"成交",phone:"151454573",cjtime:"2022-1-13 10:29",gjtime:"2022-1-13 10:29",wgjdata:23,cellphone:12345,qq:45456,emal:"123@qq.com"},
				// {id:2,enterprisename:"北京博越盛华文化发展有限公司2",resname:"王强",contactname:"王强",wechat:"151454573",satus:"初访",phone:"151454573",cjtime:"2022-1-13 10:29",gjtime:"2022-1-13 10:29",wgjdata:23,cellphone:12345,qq:45456,emal:"123@qq.com"},
				// {id:3,enterprisename:"北京博越盛华文化发展有限公司3",resname:"王强",contactname:"王强",wechat:"151454573",satus:"报价",phone:"151454573",cjtime:"2022-1-13 10:29",gjtime:"2022-1-13 10:29",wgjdata:23,cellphone:12345,qq:45456,emal:"123@qq.com"},
				// {id:4,enterprisename:"北京博越盛华文化发展有限公司4",resname:"王强",contactname:"王强",wechat:"151454573",satus:"有意向",phone:"151454573",cjtime:"2022-1-13 10:29",gjtime:"2022-1-13 10:29",wgjdata:23,cellphone:12345,qq:45456,emal:"123@qq.com"},
			],
			enterpriselist: [], //过滤后的customerdata
			sid: 4, //手机微信下拉列表
			sid2: 0, //表格跟进状态下拉列表
			contact: [{
				sid: 1,
				value: '微信'
			}, {
				sid: 2,
				value: '手机'
			}, {
				sid: 3,
				value: 'QQ'
			}, {
				sid: 4,
				value: '邮箱'
			},],
			state: [{
				sid: 0,
				value: '跟进状态'
			}, {
				sid: 1,
				value: '初访'
			}, {
				sid: 2,
				value: '有意向'
			}, {
				sid: 3,
				value: '已签约'
			}, {
				sid: 4,
				value: '已落地'
			}, {
				sid: 5,
				value: '暂时搁置'
			},],
			checkAll: false, //判读是否全选
			ischeckedlist: [], //存复选框选中列表id
			CreationTime: '', //创建时间
			LastTime: '', //最后跟进时间
			cusid: 0, //企业id
			ischeckcusdata: {}, //选中的企业数据
			customerName: '',
			addphone: '',
			addmobile: '',
			addweixin: '',
			addqq: '',
			addemail: '',
			addremark: '',
			industryoptions1: [], //行业  一级分类
			industry: '', //行业  一级分类
			industryoptions2: [], //行业  二级分类
			industry2: '',
			companyname: '',
			erromsg: '', //弹窗错误提示
			crmuserdata: {}, //crm 用户信息
			loading: false, //远程搜索加载状态
			enterpriseOptions: [], //远程搜索下拉框数据
			debounceTimer: null, // 用于存储定时器 ID
			company: '1',
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		// this.getcustomerlist();
		this.userdata = this.getuseriformation();

	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		if (this.userdata.token) {
			this.pageHandler(1);
			this.getindustry();
			this.getstaus();
		}
	},
	methods: {
		 // fetch-suggestions 方法 —— 返回下拉建议列表
		 fetchSuggestions(queryString, cb) {
			if (!queryString || queryString.trim() === '') {
				cb([]); // 如果没有输入，返回空列表
				return;
			}

			// 直接调用 API 获取匹配的企业列表
			let ajaxurl = this.$api.cyl.enterprise.list() + '?kw=' + encodeURIComponent(queryString);
			this.$axios
				.get(ajaxurl, { headers: { AuthToken: this.userdata.token } })
				.then((res) => {
				if (res.data.success) {
					let result = res.data.list;
					// 为每个选项加上 value 字段，这是 el-autocomplete 要求的
					result.forEach((item) => {
					item.value = item.title;
					});
					cb(result); // 🎯 直接将 API 返回的数据作为建议列表
				} else {
					cb([]); // 出错时返回空
				}
				})
				.catch((err) => {
				console.error('搜索建议请求失败', err);
				cb([]); // 出错也返回空
				});
			},
		handleSelect(item) {
			console.log(item);
		},
		pageHandler: function (page) {
			this.page = page;
			this.getcustomerlist(page);
		},
		stu() {
			console.log(typeof this.trackStatusvalue);
		},
		restfun() { //筛选重置
			this.companyname = '';
			this.industry = '';
			this.industry2 = '';
			this.stauslist = [];
			this.CreationTime = '';
			this.LastTime = '';
			this.personvalue = '';
			this.getcustomerlist();
		},
		detaleConfirm(id) { //删除企业提示
			var _this = this;
			this.$confirm('此操作将删除该企业, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deletecustomer(id);
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},


		//详情页跳转
		detailrouterto(path, id) {
			if (id == 0 || id == "") {
				return;
			}
			let routeUrl = this.$router.resolve({
				path: path,
				query: {
					id: id,
				},
			});
			window.open(routeUrl.href, '_blank');
		},
		remoteMethod(query) {
			// return;
			// 清除之前的定时器
			if (this.debounceTimer) {
				clearTimeout(this.debounceTimer);
			}

			// 设置新的定时器
			this.debounceTimer = setTimeout(() => {
				this._executeRemoteMethod(query);
			}, 3000); // 延迟 300ms
		},
		_executeRemoteMethod() {
			let query = this.customerName.trim();
			if (query === '') {
				this.$message({
					type: 'warning',
					message: '请输入企业名称进行搜索'
				})
				return;
			}
			if (query !== '') {
				this.loading = true;
				let ajaxurl = this.$api.cyl.enterprise.list() + '?kw=' + encodeURIComponent(query);
				this.$axios
					.get(ajaxurl, { headers: { AuthToken: this.userdata.token } })
					.then((res) => {
						if (res.data.success) {
							let result = res.data.list;
							result.forEach((item) => {
								item.value = item.title;
							})
							this.enterpriseOptions = result;
							this.loading = false;
						} else {
							this.enterpriseOptions = [];
							this.loading = false;
						}
					})
					.catch((err) => {
						console.error('请求失败', err);
						this.enterpriseOptions = [];
						this.loading = false;
					});
			} else {
				this.enterpriseOptions = [];
				this.loading = false;
			}
		},
		//企业列表
		judeajaxurl(name, value) {
			var url1 = '';
			if (value != '' && value != null && value != 0) {
				url1 = '&' + name + '=' + value;
			}
			return url1;
		},
		getcustomerlist() {
			var _this = this;
			var ajaxurl1 = this.$api.crm.customer.list() + '?page=' + this.page;
			if (this.stauslist.length > 0) {
				var trackStatus = _this.stauslist.join("%2C");
				ajaxurl1 = ajaxurl1 + '&trackStatus=' + trackStatus;
				// console.log("staust",trackStatus);
			}
			var companynamed = this.judeajaxurl('name', this.companyname); //用户名称
			var bigindustry = this.judeajaxurl('bigIndustry', this.industry); //所属行业
			var smindustry = this.judeajaxurl('smallIndustry', this.industry2); //所属行业
			var trackDate = this.judeajaxurl('trackDate', this.LastTime); //跟进时间
			var enterDate = this.judeajaxurl('enterDate', this.CreationTime); //录入时间 
			var managerId = this.judeajaxurl('managerId', this.personvalue); //负责人id
			ajaxurl1 = ajaxurl1 + companynamed + bigindustry + smindustry + trackDate + enterDate + managerId;

			console.log(ajaxurl1);
			// return ;					 
			this.$axios.get(ajaxurl1, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("企业列表", res.data);
				if (res.data.success) {

					// console.log(ajaxurl1);
					_this.customerdata = res.data.list;
					_this.pageSize = res.data.pageSize//每一页显示的数据条数
					_this.total = res.data.totalRecord//每一页显示的数据条数
					_this.totalPage = res.data.totalPage//每一页显示的数据条数 
					var getdata = res.data.list;
					_this.enterpriselist = _this.customerdata;
					for (var i = 0; i < getdata.length; i++) {
						if (_this.customerdata[i].trackTime != '') {
							_this.customerdata[i].notrackdays = _this.DateDiffer(_this.customerdata[i].trackTime);
						} else {
							_this.customerdata[i].notrackdays = _this.DateDiffer(_this.customerdata[i].enterTime);
						}
					};
					_this.personoptions = _this.uniqueMid(getdata);

					// console.log('customerdata',_this.customerdata);
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//添加企业
		addcus() {
			// console.log("企业名：",this.customerName,"跟进状态：",this.trackStatusvalue,"手机号：",this.addmobile,"电话：",this.addphone,"微信：",this.addweixin,);
			if (this.customerName == '' || this.trackStatusvalue <
				1) { //||this.addmobile==''||this.addphone==''||this.addweixin==''||this.addemail==''
				this.erromsg = '带*号为必填信息';
				return;
			}
			var _this = this;
			var adata = {
				customerId: 0,
				customerName: this.customerName,
				trackStatus: this.trackStatusvalue
			};
			// ,phone:this.addphone,mobile:this.addmobile,weixin:this.addweixin,qq:this.addqq,email:this.addemail,remark:_this.addremark
			if (this.addphone != '') {
				adata.phone = this.addphone
			}
			if (this.addmobile != '') {
				adata.mobile = this.addmobile
			}
			if (this.addweixin != '') {
				adata.weixin = this.addweixin
			}
			if (this.addqq != '') {
				adata.qq = this.addqq
			}
			if (this.addemail != '') {
				adata.email = this.addemail
			}
			if (this.addremark != '') {
				adata.remark = this.addremark
			}
			console.log(adata);
			_this.bus.$emit('loading', true);
			$.ajax({
				type: "POST",
				url: this.$api.crm.customer.post(),
				data: adata, //,trackStatus:this.trackStatus,phone:this.phone,mobile:this.mobile,weixin:this.weixin,qq:this.qq,email:this.email,remark:this.remark
				headers: {
					AuthToken: this.userdata.token
				},
				success: function (res) {

					// console.log("企业名1111：",_this.customerName,"跟进状态：",_this.trackStatusvalue,"手机号：",_this.addmobile,"电话：",_this.addphone,"微信：",_this.addweixin,'qq:',_this.addqq,'email:',_this.addemail,'备注:',_this.addremark,)
					console.log('添加企业', res);
					if (res.success) {
						// console.log("企业名2222：",_this.customerName,"跟进状态：",_this.trackStatusvalue,"手机号：",_this.addmobile,"电话：",_this.addphone,"微信：",_this.addweixin,'qq:',_this.addqq,'email:',_this.addemail,'备注:',_this.addremark,)
						_this.newadd = false;
						_this.customerName = '';
						_this.trackStatusvalue = '';
						_this.addphone = '';
						_this.addmobile = '';
						_this.addweixin = '';
						_this.addqq = '';
						_this.addemail = '';
						_this.addremark = '';
						_this.getcustomerlist();
					} else {
						_this.erromsg = res.msg;
					}
					_this.bus.$emit('loading', false);
				}
			})
		},

		//删除企业 单选删除
		deletecustomer(id) {
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.customer.delete(),
				data: {
					id: id
				},
				headers: {
					AuthToken: this.userdata.token
				},
				success: function (res) {
					console.log('11', res);
					if (res.success) {
						// _this.ischeckedlist = []; 
						// _this.getcustomerlist();
						_this.enterpriselist = _this.enterpriselist.filter(dd => {
							return dd.id != id;
						})
						_this.total--;
					}
					var successtype = res.success ? 'success' : "info";
					var successtext = res.success ? '删除成功' : res.msg;
					_this.$message({ type: successtype, message: successtext, });

				}
			})
		},
		//负责人列表
		uniqueMid(arr) {
			const res = new Map();
			return arr.filter((arr) => !res.has(arr.managerId) && res.set(arr.managerId, 1));
		},

		//计算未跟进天数
		DateDiffer(Date_end) {
			//date1最后跟进时间
			let date1 = new Date(Date_end);
			//date2当前时间
			let date2 = new Date();
			date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
			date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
			const diff = date2.getTime() - date1.getTime(); //当前时间减去最后跟进时间
			const diffDate = diff / (24 * 60 * 60 * 1000); //计算当前时间与结束时间之间相差天数
			// console.log('未跟进天数',diffDate);
			return diffDate;
		},

		//筛选 checklist：跟进状态选中列表
		ch() {
			console.log("筛选");
			// console.log(this.input);
			console.log(this.checkList);
			console.log(this.stauslist);
			// for(){

			// }
			// console.log(this.CreationTime);
			// console.log(this.LastTime);
			// console.log(this.personvalue);
		},
		//获取跟进状态
		getstaus() {
			var _this = this;
			this.$axios.get(this.$api.crm.parameter.list(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("跟进状态", res);
				if (res.data.success) {
					_this.stausoptions = res.data.list;
					_this.stausoptions.unshift({ paraValue: 0, paraName: '全部' });
					console.log(_this.stausoptions);
				} else {

				}
			}).catch(function (error) {
				console.log(error);
			})
		},
		//获取行业分类
		getindustry() {
			var _this = this;
			this.$axios.get(this.$api.cyl.parameter.get(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("行业分类", res);
				if (res.data.success) {
					_this.industryoptions1 = res.data.list;
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//下拉框联动
		indse(industry) {
			var _this = this;
			console.log('一级分类', industry);
			this.$axios.get(this.$api.cyl.parameter.get() + '?parentValue=' + industry, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("行业分类", res);
				if (res.data.success) {
					_this.industryoptions2 = res.data.list;
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//格式化日期 （时间戳）
		dateFormat(type, date) {
			var M = date.getMonth() + 1;
			M = M < 10 ? ('0' + M) : M;
			var y = date.getFullYear();
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
			var time = y + '-' + M + '-' + d;
			if (type == 1) {
				this.CreationTime = time;
			}
			if (type == 2) {
				this.LastTime = time;
			}
			console.log(time);
			return time;
		},
		//没什么用的看联系方式类型微信，手机号
		schange() {
			console.log(this.sid);
		},
		//表格跟进状态筛选数据
		schange2(data) {
			console.log(data);
			console.log(this.sid2);
			// for(var i; i<this.state.length;i++){

			// } 
			if (this.sid2 == 0) {
				this.enterpriselist = this.customerdata;
			} else {
				this.enterpriselist = data.filter(data => {
					return data.trackStatus == this.sid2 ;
				});
				console.log(this.state[this.sid2 - 1].value);
			}
			
			console.log('enterpriselist', this.enterpriselist);
		},
		//对数据进行ceked赋值，
		checkSingle(val) {
			var cus = this.customerdata;
			console.log('单选企业列表赋值', this.ischeckedlist, this.ischeckedlist.length);
			var ischecklistd = this.ischeckedlist;
		},
		//全选反选
		checkedall() {
			this.checkAll = !this.checkAll;
			var _this = this;
			this.ischeckedlist = [];
			console.log('this.checkAll:', this.checkAll);
			if (this.checkAll) {
				//全选将所有列表的id都选中
				this.customerdata.forEach(list => {
					_this.ischeckedlist.push(list.id);
				})
			}
		},
	}
}
</script>
<style lang="scss" scoped>
</style>